import * as SentryReact_ from '@sentry/react';

export const Sentry = SentryReact_;
export const SentryReact = SentryReact_;
